import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import {
  IAnalysisPackage,
  IAnalysisReplaceMultiSecsDTO,
  ISecurityDropDown,
  ISecurityDropDownItem,
  IAnalysisReplaceSecuritiesDTO
} from "@irb/irb-editors/rebalance/irb-rebalance.model";
import {RebalanceService} from "@irb/irb-editors/rebalance/rebalance.service";
import {UtilityService} from "@irb/irb-common/services/utility.service";
import {AppService} from "@irb/app.service";
import {CalltoactionService} from "@irb/irb-common/components/calltoaction/calltoaction.service";
import {IEvent, IrbAppEvents, IrbEditorsEvents, IrbModelsEvents} from "@irb/irb-common/events";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {Subscription} from "rxjs";
import {EditorBuyMultipleReplacementComponent} from "@irb/irb-editors/editor-buy-multiple-replacement/editor-buy-multiple-replacement.component";
import {DialogComponent} from "@irb-common/components/dialog/dialog.component";
import {ReplaceSecuritiesRebalSettingsGridLayoutService} from '@irb/irb-editors/editor-replace-securities-rebalance/replace-securities-rebal-settings/replace-securities-rebal-settings.grid-layout.service';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";

@Component({ standalone: false,
  selector: "irb-replace-securities-rebal-settings",
  templateUrl: "./replace-securities-rebal-settings.component.html",
  styleUrls: ["./replace-securities-rebal-settings.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ReplaceSecuritiesRebalSettingsComponent implements OnInit, OnDestroy {
  @Output() change = new EventEmitter<any>();
  gridOptions: any;
  grid: any;
  _isReadOnly: boolean;
  securityDropDownRes: ISecurityDropDown = {} as ISecurityDropDown;
  securityDropDown: ISecurityDropDownItem = {} as ISecurityDropDownItem;
  securityDropDownList: ISecurityDropDownItem[];
  replaceMultipleSecurities: IAnalysisReplaceMultiSecsDTO[] = [];
  analysisPackage: IAnalysisPackage;
  stPercent: number = null;
  totalPercent: number = null;
  //securitySymbols: SelectItem[] = [];
  selectedSecuritySymbol: string;
  securitySymbolsGrid: string[] = [];
  mouseEvent: any;
  numSec: number = 0;
  secuitySymbolMap: Map<string, ISecurityDropDownItem> = new Map();
  secuityIdMap: Map<number, ISecurityDropDownItem> = new Map();
  tooltipMessage: string;
  toolTipShow: boolean;
  selectedSecToAdd: any;
  securitySymbolsDD: Array<IDropdownItem> = [];
  originalValue: any;
  dupelems: any = [];
  addNewSecurityItem: any = {
    button: 'Add new security',
    type: 'security',
    fromComp: 'ReplaceSecuritiesRebalSettingsComponent'
  };

  capBuyPer: Array<IDropdownItem> = [
    { value: "NONE", name: "None" },
    { value: "MODEL_PCT", name: "Model %" },
    { value: "SPECIFY_PCT", name: "Specify %" },
  ];
  
  @ViewChild("replaceSecDropDown") replaceSecDropDown: any;
  replaceSecDropDpwnData: Array<IDropdownItem> = [];
  replaceSecTargets: Array<IDropdownItem> = [];
  //hasReplaceSecTargets: boolean = false;
  private eventSubscription: Subscription;
  @ViewChild("dialog") dialog: DialogComponent;
  isUiTest = false;
  securitySymbols: any[] = [];
  loadingSecurities: boolean = false;
  frameworkComponents: any;

  constructor(
    private cdr: ChangeDetectorRef, 
    private util: UtilityService, 
    private readonly rebalanceService: RebalanceService, 
    private as: AppService, 
    private ctas: CalltoactionService, 
    private ies: IrbEditorsService,
    private gls: ReplaceSecuritiesRebalSettingsGridLayoutService
    ) {}

  ngOnInit(): void {

    this.getSecuritiesDropDown();

    this.gridOptions = {
      columnDefs: this.isReadOnly ? this.gls.getDisabledColumnDefs(this) : this.gls.getColumnDefs(this),      
      context: { componentParent: this },
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No Securities for replacement</span>",
      rowSelection: "multiple",
      onCellValueChanged: (e: any) => this.cellValueChanged(e),
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
    
    this.numSec = 0;

    this.eventSubscription = this.as.getEvents().subscribe((s) => {
      this.processEvent(s);
    });
  }

  getSecuritiesDropDown() {
    let cashSymbolId: any;
    this.loadingSecurities = true;
    this.rebalanceService.getSecuritiesDropDown().subscribe((res: ISecurityDropDown) => {
      this.securityDropDownRes = res;
      this.securityDropDownRes.items.forEach((element) => {
        //this.securitySymbols.push({ label: element.securitySymbol, value: element.securitySymbol });
        this.securitySymbolsGrid.push(element.securitySymbol);

        if (element.securitySymbol === "$CASH") {
          this.secuitySymbolMap.set("None (leave in cash)", element);
        } else {
          this.secuitySymbolMap.set(element.securitySymbol, element);
        }
        this.secuityIdMap.set(element.securityId, element);

        if (element.securitySymbol === "$CASH") {
          cashSymbolId = element.securityId;
        } else {
          this.securitySymbolsDD.push({ value: element.securityId, name: element.securitySymbol });
        }
        this.securitySymbols.push({ value: element.securityId, name: element.securitySymbol });

      });

      this.securitySymbolsGrid = this.sortArrayList(this.securitySymbolsGrid);
      this.securitySymbolsGrid[this.securitySymbolsGrid.indexOf("$CASH")] = "None (leave in cash)";

      this.securitySymbolsDD = this.util.sortByKey(this.securitySymbolsDD, "name","asc");
      this.securitySymbolsDD.unshift({ value: null, name: "Multiple replacements", class: ["underline"]});

      if (cashSymbolId) {
        this.securitySymbolsDD.unshift({ value: null, name: "None (leave in cash)" });
      }
      this.securitySymbols.sort((a: any, b: any) => {
        return (a.name < b.name) ? -1: 1;
      });
      this.loadingSecurities = false;
      this.refreshGrid();
    });
  }

  ngOnDestroy(): void {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

  private processEvent(event: IEvent) {
    switch (event.type) {
      case IrbEditorsEvents.SHOW_BUY_MULTIPLE_REPLACEMENT:
        this.showBuyMultipleReplacement(event.data);
        break;
      case IrbEditorsEvents.UPDATE_FROM_BUY_MULTIPLE_REPLACEMENT:
        this.updateWithMultiple(event.data);
        break;
      case IrbModelsEvents.SAVE_MASTER_MULTIPLE_SECURITY:
        if (event.data && event.data.type === "rebalance") {
          this.updateWithMultipleSecurity(event.data);
        }
        break;
      case IrbModelsEvents.SAVE_CREATE_NEW_SECURITY:
        if (event.data) {
          if (event.data.type === 'security' && (event.data.fromComp === 'ReplaceSecuritiesRebalSettingsComponent' || event.data.fromComp === 'ReplaceSecuritiesRebalSettingsGridLayoutService')) {
            const forGrid: boolean = event.data.fromComp === 'ReplaceSecuritiesRebalSettingsGridLayoutService' ? true : false;
            this.resetSecuritySearch(event.data, forGrid)
          }
        }
        break;
    }
  }

  updateWithMultipleSecurity(eventData: any) {
   this.dupelems = [];
    this.replaceSecTargets = eventData.selectedSecurities;
    this.replaceMultipleSecurities.forEach((existingSec: any) => {
      this.replaceSecTargets.forEach((newsec: any) => {
        if (existingSec.securityId === newsec.securityId && existingSec.isUIdeleted === false) {
          this.dupelems.push(newsec);
        }
      });
    });

    this.dupelems.forEach((dup: any) => {
      this.replaceSecTargets = this.replaceSecTargets.filter((x: any) => {
        return x.securityId != dup.securityId;
      });
    });

    //this.change.emit(true);
    this.replaceSecTargets.forEach((x: any) => {
      this.replaceMultipleSecurities.push({
        securityId: x.securityId,
        securitySymb: x.securitySymbol,
        replacedSymbol: "",
        toSellPercent: 100,
        shortTermGainPercent: null,
        totalGainPercent: null,
        isNew: true,
        isUIdeleted: false,
        mutipleSecurityAllocations: [
          {
            securityId: this.secuitySymbolMap.get("None (leave in cash)").securityId,
            allocationPercent: 100,
            replaceMultipleSecuritiesId: null,
            isNew: true
          }
        ],
        replaceMultipleSecuritiesId: null,
        analysisReplaceSecuritiesId: 76372,
        isSwapExchange: false,
        capType: "NONE",
        capPercent: null,
      } as IAnalysisReplaceMultiSecsDTO);
      this.numSec = this.numSec + 1;
    });

    this.refreshGrid();
    this.analysisPackage.replaceSecsDto.replaceMultipleSecurities = this.replaceMultipleSecurities;
    this.change.emit(this.analysisPackage);
    this.replaceSecDropDown.clear();
  }

  updateWithMultiple(eventData: any) {
    const updatedSecId = eventData.data.securityId;
    let rowIndex: number = -1;

    this.grid.api.forEachNode((node: any) => {
      if (node.data.securityId === updatedSecId) {
        rowIndex = node.rowIndex;
        node.data.replacedType = null;

        if(eventData.replacements.length > 0) {
          let multipleReplacements: any[] = this.util.clone(node.data.mutipleSecurityAllocations);

          if(multipleReplacements === undefined || multipleReplacements === null ) {
            multipleReplacements = [];
          }

          multipleReplacements.forEach((repl: any)=>{
            repl.isUIdeleted = true;
          });

          for(let i =0; i< eventData.replacements.length; i++) {
            let replacement = eventData.replacements[i];
            let existingReplacement = multipleReplacements.find((x:any)=>{return x.securityId === replacement.securityId;});

            if(existingReplacement) {
                if(replacement.isUIdeleted) {
                  existingReplacement.isUIdeleted = true;
                } else {
                  existingReplacement.isUIdeleted = false;
                  existingReplacement.allocationPercent = replacement.allocationPercent;
                }
            } else {
                let securityMapItem = this.secuityIdMap?.get(replacement.securityId);
                let replaceMultipleSecuritiesId = node.data.replaceMultipleSecuritiesId;
                let replaceSecurityItem: any = {
                  multipleSecuritiesId : '',
                  securityId : replacement.securityId,
                  securitySymb : replacement.securitySymb,
                  securityType: securityMapItem.securityType,
                  allocationPercent : replacement.allocationPercent,
                  replaceMultipleSecuritiesId : replaceMultipleSecuritiesId,
                  isUIdeleted : false,
                  isNew: true,
                  isDeleted: false,
                  isSwapExchange: null
                };

                multipleReplacements.push(replaceSecurityItem);
            }
          }

          const c = multipleReplacements.filter((item: any) => !item.isUIdeleted).length;
          node.data.replacedSymbol = (c > 0) ? "(multiple)" : "None (leave in cash)";
          node.data.mutipleSecurityAllocations = multipleReplacements;
        } else {
          node.data.replacedSymbol = "None (leave in cash)";
          node.data.mutipleSecurityAllocations = null;
        }
      }
    });

    if (rowIndex !== -1) {
      const n = this.grid.api.getDisplayedRowAtIndex(rowIndex);
      this.grid.api.redrawRows({ rowNodes: [n] });
    }
  }


  showBuyMultipleReplacement(eventData: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    config.data = eventData;
    this.dialog.open(EditorBuyMultipleReplacementComponent, config);
  }

  onGridReady(params: any) {
    this.grid = params;
    if (this.analysisPackage.replaceSecsDto.replaceMultipleSecurities != null) {
      this.replaceMultipleSecurities = this.analysisPackage.replaceSecsDto.replaceMultipleSecurities;
      this.replaceMultipleSecurities.forEach((element) => {
        if (element.mutipleSecurityAllocations != null && element.mutipleSecurityAllocations.length === 1) {
          if (element.mutipleSecurityAllocations[0].securitySymb === "$CASH") {
            element.replacedSymbol = "None (leave in cash)";
          } else {
            element.replacedSymbol = element.mutipleSecurityAllocations[0].securitySymb;
          }
        } else if (element.mutipleSecurityAllocations != null && element.mutipleSecurityAllocations.length > 1) {
          element.replacedSymbol = "(multiple)";
        }
        //sa ??? - not in hammer code date 1/7/21 rav794
        // if (element.capType === "MODEL_PCT") {
        //   element.capTypeDropDown = "Model %";
        // } else if (element.capType === "SPECIFY_PCT") {
        //   element.capTypeDropDown = "Specify %";
        // } else {
        //   element.capTypeDropDown = "None";
        // }
      });
      this.numSec = this.getRowCount();
      this.grid.api.setGridOption('rowData', this.replaceMultipleSecurities);
      // setTimeout(() => {
      //   if (this.grid && this.grid.api) {
      //     this.grid.api.sizeColumnsToFit();
      //   }
      // });
    } else {
      params.api.showNoRowsOverlay();
    }
  }

  refreshGrid() {
    if(this.grid && this.grid.api) {
      this.grid.api.deselectAll();
      this.grid.api.hideOverlay();
      this.grid.api.setGridOption('rowData', this.replaceMultipleSecurities);

      // setTimeout(() => {
      //   if (this.grid && this.grid.api) {
      //     this.grid.api.sizeColumnsToFit();
      //   }
      // });
    }
  }

  onAllowInModified() {
    this.change.emit(true);
  }

  updateSTPrec() {
    //this.change.emit(true);
    this.stPercent = (this.stPercent as any) === '' ? null : this.stPercent;
    this.replaceMultipleSecurities.forEach((element) => {
      element.shortTermGainPercent = this.stPercent;
    });
    this.refreshGrid();
    this.analysisPackage.replaceSecsDto.replaceMultipleSecurities = this.replaceMultipleSecurities;
    this.change.emit(this.analysisPackage);
  }

  updateTotalPrec() {
    //this.change.emit(true);
    this.totalPercent = (this.totalPercent as any) === '' ? null : this.totalPercent;
    this.replaceMultipleSecurities.forEach((element) => {
      element.totalGainPercent = this.totalPercent;
    });
    this.refreshGrid();
    this.analysisPackage.replaceSecsDto.replaceMultipleSecurities = this.replaceMultipleSecurities;
    this.change.emit(this.analysisPackage);
  }
  // not found usage of it
  // checkDuplicateSecurity() {
  //   if (this.analysisPackage.replaceSecsDto.replaceMultipleSecurities) {
  //     let selectedSymbol = this.selectedSecToAdd.securitySymb;
  //     return this.analysisPackage.replaceSecsDto.replaceMultipleSecurities.some((elem: any) => {
  //       return elem.securitySymb === selectedSymbol;
  //     });
  //   } else {
  //     false;
  //   }
  // }

  captureAddSecurity(event: any) {
    this.toolTipShow = false;
    this.tooltipMessage = "";
    let replSecType = "";
    this.securityDropDownRes.items.forEach((element: any) => {
      if (event.originalEvent && element.securitySymbol === event.originalEvent.target.innerText) {
        replSecType = element.securityType;
      }
    });

    this.selectedSecToAdd = {
      securityId: event.value,
      securitySymb: this.selectedSecuritySymbol,
      replacedSymbol: "",
      toSellPercent: 0,
      shortTermGainPercent: 0,
      totalGainPercent: 0,
      isUIdeleted: false,
    };
  }

  getReplaceSecurities(searchStr: any) {
    if (!searchStr || (searchStr && searchStr.trim() === "")) {
      this.replaceSecDropDown.set([]);
      return;
    }
    let interval = 0;
    let timeInterval = setInterval(() => {
      if (!this.loadingSecurities) {
        clearInterval(timeInterval);
        this.replaceSecDropDown.set(DropdownFilterComponent.getFilteredList(searchStr, this.securitySymbols));
      }
      interval = 1000;
    }, interval);
  }

  onReplaceSecChange(s: any) {
    this.replaceSecTargets = s;
  }

  disableAddReplaceSec(){
    return this.replaceSecTargets !== null && this.replaceSecTargets.length > 0;
  }

  addSecurities() {
    this.dupelems = [];
    this.replaceMultipleSecurities.forEach((existingSec: any) => {
      this.replaceSecTargets?.forEach((newsec: any) => {
        if (existingSec.securityId === newsec.value && existingSec.isUIdeleted === false) {
          this.dupelems.push(newsec);
        }
      });
    });

    if (this.dupelems.length > 0) {
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: "warn",
        summary: "",
        detail: "Security(ies) cannot be listed twice.",
      });
    }

    this.dupelems.forEach((dup: any) => {
      this.replaceSecTargets = this.replaceSecTargets.filter((x: any) => {
        return x.value != dup.value;
      });
    });

    //this.change.emit(true);
    this.replaceSecTargets.forEach((x: any) => {
      this.replaceMultipleSecurities.push({
        securityId: x.value,
        securitySymb: x.name,
        //securityType: this.secuitySymbolMap.get(x.name).securityType,
        securityType: (this.secuitySymbolMap.get(x.name)) ? this.secuitySymbolMap.get(x.name).securityType : null,
        replacedSymbol: "None (leave in cash)",
        replacedType: null,
        toSellPercent: 100,
        shortTermGainPercent: null,
        totalGainPercent: null,
        isNew: true,
        isUIdeleted: false,
        mutipleSecurityAllocations: [
          {
            securityId: this.secuitySymbolMap.get("None (leave in cash)").securityId,
            allocationPercent: 100,
            replaceMultipleSecuritiesId: null,
            isNew: true
          }
        ],
        replaceMultipleSecuritiesId: null,
        analysisReplaceSecuritiesId: 76372,
        isSwapExchange: false,
        capType: "NONE",
        capPercent: null
      } as IAnalysisReplaceMultiSecsDTO);
      this.numSec = this.numSec + 1;
    });

    this.refreshGrid();
    this.analysisPackage.replaceSecsDto.replaceMultipleSecurities = this.replaceMultipleSecurities;
    this.change.emit(this.analysisPackage);
    this.replaceSecDropDown.clear();
  }

  cellValueChanged(params: any) {
    const rowIndex = params.node.rowIndex;
    const rowSymbol = params.data.securitySymb;
    const colId = params.column.colId;
    const newVaue = params.newValue;

    if (colId === "replacedSymbol") {
      if (newVaue) {
        this.replaceMultipleSecurities.forEach((element) => {
          if (element.securitySymb === rowSymbol) {
            element.mutipleSecurityAllocations[0].securityId = this.secuitySymbolMap.get(newVaue).securityId;
          }

          if (this.secuitySymbolMap.get(newVaue).securityType === "MUTUAL_FUND" && this.secuitySymbolMap.get(element.securitySymb).securityType === "MUTUAL_FUND") {
            element.securityType = "MUTUAL_FUND";
          } else {
            element.securityType = "";
          }
        });
      }
    } else if (colId === "capTypeDropDown") {
      this.replaceMultipleSecurities.forEach((element) => {
        if (newVaue === "Model %") {
          element.capType = "MODEL_PCT";
        } else if (newVaue === "Specify %") {
          element.capType = "SPECIFY_PCT";
        } else {
          element.capType = "NONE";
        }
      });
    }

    this.analysisPackage.replaceSecsDto.replaceMultipleSecurities = this.replaceMultipleSecurities;
    const n = this.grid.api.getDisplayedRowAtIndex(rowIndex);
    this.grid.api.redrawRows({ rowNodes: [n] });
    this.change.emit(this.analysisPackage);
  }

  @Input()
  get isReadOnly() {
    return this._isReadOnly;
  }

  set isReadOnly(isReadOnly: boolean) {
    this._isReadOnly = isReadOnly;
  }

  @Input()
  get data() {
    return this.analysisPackage;
  }

  set data(data: IAnalysisPackage) {
    this.analysisPackage = data;
  }

  deleteAll() {
    this.replaceMultipleSecurities.forEach((item: any) => { item.isUIdeleted = true; });
    this.analysisPackage.replaceSecsDto.replaceMultipleSecurities = null;
    this.numSec = 0;
    this.refreshGrid();
    this.change.emit(this.analysisPackage);
  }

  delete(cc: any) {
    for (let i = 0; i < this.replaceMultipleSecurities.length; i++) {
      if (this.replaceMultipleSecurities[i].securitySymb === cc.securitySymb) {
        if(this.replaceMultipleSecurities[i].isNew) {
          this.replaceMultipleSecurities.splice(i--, 1);
        } else {
          this.replaceMultipleSecurities[i].isUIdeleted = true;
        }
      }
    }

    this.numSec = this.replaceMultipleSecurities.filter((item: any) => !item.isUIdeleted).length;
    this.refreshGrid();
    this.analysisPackage.replaceSecsDto.replaceMultipleSecurities = this.replaceMultipleSecurities;
    this.change.emit(this.analysisPackage);
  }

  cancelDelete() {
    this.ctas.remove();
  }

  getRowCount() {
    const count = this.replaceMultipleSecurities?.filter((elem: any) => elem.isUIdeleted === false);
    return count.length;
  }

  sortArrayList(arrayList: string[]) {
    return arrayList.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
  }

  showAddMultipleSecuritiesDialog() {
    let dataInputForMultipleSelection:any=[];
    this.grid.api.forEachNode((node:any) => {
      if (!node.data.isUIdeleted)
        dataInputForMultipleSelection.push(node.data);

    });
    const params = {
      type: "rebalance",
      data:dataInputForMultipleSelection,
      noDollarcash: true
    };
    this.as.fireEvent(IrbModelsEvents.SHOW_MASTER_MULTIPLE_SECURITY, params);
  }

  isGridEditable() {
    return this.isReadOnly;
  }

  isCapPercentEditable(params: any) {
    let isEditable = true;
    if (params.data.capType === "MODEL_PCT" || params.data.capType === "NONE") {
      isEditable = false;
    } else {
      isEditable = true;
    }

    return isEditable;
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass(node: any) {
    return !node.data.isUIdeleted;
  }

  warnIfSymbolUsedAsEquityReplaceTarget(replacedSymbol: string) {
    if(this.checkIfSymbolUsedAsEquityReplaceTarget(replacedSymbol)) {
      const rn: any = [];
      let disabledSwapExchCount = 0;

      this.grid.api.forEachNode((node: any) => {
        if(node.data.replacedSymbol === replacedSymbol && !node.data.isUIdeleted) {
          if(node.data.isSwapExchange) {
            node.data.isSwapExchange = false;
            disabledSwapExchCount++;
          }

          rn.push(node);
        }
      });

      if(rn.length > 0) {
        this.grid.api.redrawRows({ rowNodes: rn });

        if(disabledSwapExchCount > 0) {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: "warn",
            summary: "Fund " + replacedSymbol + " is already listed as a replacement buy security.",
            detail: "The Swap/Exch checkbox has been unchecked to be consistent with all replacement securities.",
            sticky: true
          });
        }
      }
    }
  }

  checkIfSymbolUsedAsEquityReplaceTarget(replacedSymbol: string) {
    const f = this.replaceMultipleSecurities.find((x: IAnalysisReplaceMultiSecsDTO) => x.securityType !== "MUTUAL_FUND" && x.replacedSymbol === replacedSymbol);
    return (f) ? true : false;
  }

  getDefaultValueForCapType(capType: string) {
    return this.capBuyPer.find((x: IDropdownItem) => x.value === capType);
  }
  openNewItemSecurityFlow(dataParam: any, forGrid: boolean) {
    if (!forGrid) {
    dataParam = Object.assign({}, this.addNewSecurityItem, dataParam);
    }
    this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
  }

  resetSecuritySearch(dataParam: any, forGrid: boolean) {
    if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
      this.securitySymbolsDD = this.securitySymbolsDD.concat(dataParam.newItemsForDD);
      let newItem: any;
      dataParam.securities.responseData.forEach((newSec: any) => {
        newItem = {
          securityDescription: newSec.securityDescription,
          securityId: newSec.securityId,
          securitySymbol: newSec.securitySymbol,
          securityType: newSec.securityType
        };
        this.securityDropDownRes.items.push(newItem);
      });
      if(!forGrid) {
        this.replaceSecTargets = dataParam.newItemsForDD
        this.replaceSecDropDown.setValue(dataParam.newItemsForDD);
        this.captureAddSecurity(dataParam.newItemsForDD);
        this.getSecuritiesDropDown();
      } else {
        const rowIndex: number = dataParam.rowIndex;

        if (rowIndex !== null || typeof rowIndex !== "undefined") {
            this.grid.api.forEachNode((node: any) => {
                if (node.rowIndex === rowIndex) {
                    node.data.replacedSymbol = dataParam.newItemsForDD[0].name;
                    node.data.mutipleSecurityAllocations = [];
                    node.data.mutipleSecurityAllocations.push({
                      replaceMultipleSecuritiesId: null,
                      securityId: dataParam.newItemsForDD[0].value,
                      securitySymb: dataParam.newItemsForDD[0].name,
                      allocationPercent: 100,
                      isNew: true
                    });
                }
            });
            const n = this.grid.api.getDisplayedRowAtIndex(rowIndex);
            this.grid.api.redrawRows({rowNodes: [n]});
        }
      }
    }
  }

  setMutipleSecurityAllocations(mutipleSecurityAllocations: Array<any>, v: any) {
    if(mutipleSecurityAllocations) {
      //const noneId = this.secuitySymbolMap.get("None (leave in cash)").securityId;

      for(let i = 0; i < mutipleSecurityAllocations.length; i++) {
        if(mutipleSecurityAllocations[i].isNew) {// || mutipleSecurityAllocations[i].securityId === noneId) {
          mutipleSecurityAllocations.splice(i--,1);
        } else {
          mutipleSecurityAllocations[i].isUIdeleted = true;
        }
      }
    } else {
      mutipleSecurityAllocations = [];
    }

    if(v) {
      v.isNew = true;
      mutipleSecurityAllocations.push(v);
    }

    return mutipleSecurityAllocations;
  }
}
